// @mui
import { Stack, Box } from '@mui/material';
// config
import { useMemo } from 'react';
import { CheckEnvironment, NAV, SupportedEnvironments } from '../../../config-global';
// utils
import { hideScrollbarX } from '../../../utils/cssStyles';
// components
import Logo from '../../../components/logo';
import { NavSectionMini } from '../../../components/nav-section';
//
import navConfig, { navConfigAdmin, navDemo } from './config-navigation';
import NavToggleButton from './NavToggleButton';
import { useAuthContext } from '../../../auth/useAuthContext';
import { routeRoleAsAdmin, allowRoleToSeeDevTab } from '../../../assets/data';

// ----------------------------------------------------------------------

const devMode = CheckEnvironment(SupportedEnvironments.Dev)

export default function NavMini() {
  const { user } = useAuthContext()
  const sessionCanSeeAdminPages = routeRoleAsAdmin(user?.role);
  const sessionCanSeeDevTab = allowRoleToSeeDevTab(user?.role)
  const navigationConfig = useMemo(() => {
    if (sessionCanSeeAdminPages) {
      if (devMode && sessionCanSeeDevTab) {
        return [...navConfigAdmin, ...navDemo]
      }
      return navConfigAdmin
    }
    if (devMode && sessionCanSeeDevTab) {
      return [...navConfig, ...navDemo]
    }
    return navConfig
  }, [sessionCanSeeAdminPages, sessionCanSeeDevTab])
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_DASHBOARD_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScrollbarX,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini data={navigationConfig} />
      </Stack>
    </Box>
  );
}
